<template>
  <!-- Conditional rendering of prices based on discount -->
  <div :class="className">

    <template v-if="prices.is_b2b === true">

      <div v-if="prices.previous_show_with_taxes" :class="dynamicClassName">
        <div :class="prices.previous_price_class">
          {{ prices.previous_formatted_price_with_tax }}
        </div>
      </div>
      <div v-else :class="dynamicClassName">
        <div :class="prices.previous_price_class">
          {{ prices.previous_formatted_price }}
        </div>
      </div>

      <div v-if="prices.previous_price_title" class="price_title">
        {{ prices.previous_price_title }}
      </div>

      <div v-if="prices.current_show_with_taxes" :class="dynamicClassName">
        <div :class="prices.current_price_class">
          {{ prices.current_formatted_price_with_tax }}
        </div>
      </div>
      <div v-else :class="dynamicClassName">
        <div :class="prices.current_price_class">
          {{ prices.current_formatted_price }}
        </div>
      </div>

      <div v-if="prices.current_price_title" class="price_title" :class="prices.current_price_class">
        {{ prices.current_price_title }}
      </div>

    </template>

    <template v-else>

      <span v-if="prices.current_show_with_taxes" :class="dynamicClassName">
        <span :class="prices.current_price_class">
          {{ prices.current_formatted_price_with_tax }}
        </span>
      </span>
      <span v-else :class="dynamicClassName">
        <span :class="prices.current_price_class">
          {{ prices.current_formatted_price }}
        </span>
      </span>

      <template v-if="prices.is_active_discount || prices.is_active_special_discount">
        <del v-if="prices.current_show_with_taxes">{{ prices.previous_formatted_price_with_tax }}</del>
        <del v-else>{{ prices.previous_formatted_price }}</del>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: "ProductPrice",

  props: {
    prices:    Object,
    className: String,
  },

  computed: {
    // Dynamically generate the class name
    dynamicClassName() {
      return {
        'text-red': this.className === 'single__price',
      };
    },
  },

  data() {
    // Use a comment to explain the purpose of the data property
    return {
      show_prices_with_tax: true,
    };
  },
};
</script>
